import React from 'react'
import { Tag } from 'antd'
import { getMerchantsStatus } from 'helpers/format'

type Props = {
  verified: boolean
  rejected?: boolean
}

const MerchantStatusTag = (props: Props) => {
  const { verified, rejected = false } = props
  const text = getMerchantsStatus(verified, rejected)
  let color = 'orange'
  if (verified && !rejected) {
    color = 'green'
  }
  if (rejected) {
    color = 'red'
  }
  return <Tag color={color}>{text}</Tag>
}

export default MerchantStatusTag
